export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=ec3fffbc&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/events/id/index.vue?vue&type=template&id=ec3fffbc&
// module id = 1127
// module chunks = 0